export const ProfessionalTypeNecessary = [
    { value: 'Advogado', label: 'Advogado' },
    { value: 'Preposto', label: 'Preposto' },
    { value: "Advogado_Preposto", label: 'Advogado + Preposto' }
];